'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var components_Body2_index = require('../Body2/index.js');
var FormControlLabel = require('@mui/material/FormControlLabel');
var MuiSwitch = require('@mui/material/Switch');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var FormControlLabel__default = /*#__PURE__*/_interopDefaultLegacy(FormControlLabel);
var MuiSwitch__default = /*#__PURE__*/_interopDefaultLegacy(MuiSwitch);

var StyledFormControlLabel = styled__default["default"](FormControlLabel__default["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject([""], [""])));
var StyledSwitch = styled__default["default"](MuiSwitch__default["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  .Mui-checked {\n    color: ", ";\n  }\n  .MuiSwitch-track {\n    background-color: ", ";\n    opacity: 1;\n  }\n  .Mui-checked + .MuiSwitch-track {\n    background-color: ", ";\n  }\n"], ["\n  .Mui-checked {\n    color: ", ";\n  }\n  .MuiSwitch-track {\n    background-color: ", ";\n    opacity: 1;\n  }\n  .Mui-checked + .MuiSwitch-track {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var action = _a.theme.colors.button.action;
    return action;
}, function (_a) {
    var stroke = _a.theme.colors.background.stroke;
    return stroke;
}, function (_a) {
    var information = _a.theme.colors.background.information;
    return information;
});
var LabelText = styled__default["default"](components_Body2_index["default"])(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: inline-block;\n  margin-left: 5px;\n"], ["\n  display: inline-block;\n  margin-left: 5px;\n"])));
var Switch = React__default["default"].forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.checked, checked = _b === void 0 ? false : _b, onChange = _a.onChange, disabled = _a.disabled, name = _a.name, className = _a.className, _c = _a.label_placement, label_placement = _c === void 0 ? constants_properties.SWITCH_LABEL_PLACEMENT.END : _c;
    return (React__default["default"].createElement(StyledFormControlLabel, { ref: ref, labelPlacement: label_placement, className: className, control: React__default["default"].createElement(StyledSwitch, { checked: checked, onChange: function (_event, checked) { return onChange && onChange(checked); }, name: name, disabled: disabled }), label: React__default["default"].isValidElement(children) ? (children) : (React__default["default"].createElement(LabelText, null, children)) }));
});
var templateObject_1, templateObject_2, templateObject_3;

exports["default"] = Switch;
